import { useState } from "react";

export const useLocalStorage = (keyName: string, defaultValue: any) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(keyName);
            if (item) {
                return JSON.parse(item);
            } else {
                window.localStorage
                    .setItem(keyName, JSON.stringify(defaultValue));
                return defaultValue;
            }
        } catch (error) {
            return defaultValue;
        }
    });

    const setValue = (newValue: any) => {
        try {
            window.localStorage.setItem(keyName, JSON.stringify(newValue));
        } catch (error: any) {
            console.log(error);
        }

        setStoredValue(newValue);
    }

    return [storedValue, setValue];
}